<template>
    <f7-page
        :hide-bars-on-scroll="isPgap ? true : false"
        :class="`unit-page font-${fontSize}`"
        name="Transcript"
        no-swipeback
    >
        <f7-navbar
            no-hairline
            no-shadow
            inner-class="unitNavbar"
        >
            <f7-nav-left>
                <f7-link
                    aria-label="FontSize"
                    href="#"
                    style="padding: 6px 0 0 16px;"
                    @click="setFontSize"
                >
                    <span style="font-family: Editor; font-weight: bold; vertical-align: bottom">A<span style="font-size: 28px">A</span></span>
                </f7-link>
            </f7-nav-left>
            <f7-nav-title />
            <f7-nav-right>
                <f7-link
                    aria-label="Close"
                    href="#"
                    style="padding: 0 10px 0;"
                    back
                >
                    <i
                        class="icon ion-close-round"
                        style="font-size: 20px"
                    />
                </f7-link>
            </f7-nav-right>
        </f7-navbar>
        <div class="slide default">
            <div
                class="scroll"
                style="max-width: 100vw; overflow-x: hidden;"
            >
                <h1 style="margin-top: 5vh; padding: 0 10px;">{{ attachment.title }}</h1>
                <div class="description">Audio transcript</div>
                <div class="wave postDesc" />
                <div
                    v-if="attachment && attachment.data && attachment.data.transcript"
                    :class="`html padded default`"
                    v-html="renderText(attachment.data.transcript)"
                />
                <br><br><br><br>
            </div>
        </div>
    </f7-page>
</template>

<script>
import utils from '../../js/utils';

export default {
    store: [
        'api',
        'attachment',
        'fontSize',
        'darkTheme',
    ],
    components: {

    },
    data () {
        return {
            currentId: 0,
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        }
    },
    created: function () {

        if (this.$f7route.params.id) {
            this.currentId = parseFloat(this.$f7route.params.id);
        }
        if (this.attachment && this.attachment.id !== this.currentId) {
            this.getAttachment()
        }
        this.trackShowTranscript();

    },

    methods: {
        trackShowTranscript: function () {
            if (!this.firstShowTranscript) {
                this.$events.fire('trackEvent', 'transcript_show', 'content', this.attachment.id, this.attachment.title);
                this.firstShowTranscript = true;
            }
        },
        getAttachment: function () {
            this.$http.get(`${this.api}/attachments/${this.currentId}`).then(
                response => {
                    this.attachment = response.body || {};
                },
                () => { }
            );
        },
        renderText: function (text) {
            // remove already set targets
            text = text.replace(/(<a [^>]*)(target="[^"]*")([^>]*>)/gi, '$1$3');
            // remove already set classes
            text = text.replace(/(<a [^>]*)(class="[^"]*")([^>]*>)/gi, '$1$3');
            // add new target="_blank"
            let destination = pgap ? '_system' : '_blank';
            return text.replace(/(<a [^>]*)(>)/gi, '$1 target="' + destination + '" class="external" $2');
        },
        setFontSize: function () {
            f7.dialog
                .create({
                    title: 'Coral',
                    text: 'Choose a font size',
                    buttons: [
                        {
                            text: '<span style="font-size: 24px">Large</span>',
                            onClick: () => {
                                this.fontSize = 'large';
                                localStore.setItem('fontSize', this.fontSize);
                            }
                        },
                        {
                            text: 'Normal',
                            onClick: () => {
                                this.fontSize = 'normal';
                                localStore.setItem('fontSize', this.fontSize);
                            }
                        },
                        {
                            text: '<span style="font-size: 14px">Small</span>',
                            onClick: () => {
                                this.fontSize = 'small';
                                localStore.setItem('fontSize', this.fontSize);
                            }
                        }
                    ],
                    verticalButtons: true
                })
                .open();
        },
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.center {
    text-align: center;
    width: 100%;
}
.bottom {
    position: absolute;
    bottom: 40px;
}
.coralButton {
    font-size: 18px;
    color: white;
    background: #a5acc4;
    border-radius: 22px;
    padding: 15px 30px;
}
#slides {
    padding-top: 0px;
    margin-top: calc(0 - var(--f7-navbar-height) - var(--f7-navbar-large-title-height));
    height: 100%;
}
@media (min-height: 630px) and (min-width: 630px) {
    #slides {
        height: var(--f7-popup-tablet-height);
    }
}

.progressBar {
    display: none;
    position: fixed;
    bottom: 0px;
    background: #e0e0e0;
    width: 100%;
    height: 10px;
    z-index: 9;
    .progress {
        background: @green;
        height: 10px;
        -webkit-transition: width 2s;
        transition: width 2s;
    }
}

.nextButton {
    z-index: 9999;
    margin-left: -35px;
    left: 50%;
    position: fixed;
    bottom: 60px;
    background: @green;
    color: white;
    height: 70px;
    width: 70px;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    i {
        color: white;
        font-size: 40px;
        line-height: 78px;
    }
    &.hasChat {
        margin-left: 35px;
    }
    &.chat {
        margin-left: -105px;
    }
}
.dark .nextButton {
    z-index: 9999;
    margin-left: -35px;
    left: 50%;
    position: fixed;
    bottom: 60px;
    background: white;
    color: @green;
    height: 70px;
    width: 70px;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    i {
        color: @green;
        font-size: 40px;
        line-height: 78px;
    }
}
.unitToolbar {
    padding: 0 20px;
    background: @background;
    text-transform: uppercase;
    font-family: AndesMedium;
    letter-spacing: 1px;
    // font-size: 12px;
    a {
        padding: 16px;
        color: @coral;
        font-size: 12px;
    }
    // letter-spacing: 1px;
    // text-align: center;
    // line-height: 10px;
}
.theme-dark {
    .unitToolbar {
        background: #1c1c1d;
    }
}
.references {
    text-align: left;
    position: fixed;
    top: 60px;
    margin: 100px 0 0 -150px;
    left: 50%;
    width: 300px;
    padding: 0px;
    background: @coral;
    color: white;
    a {
        color: white !important;
        text-decoration: underline;
    }
    z-index: 12001;
    max-width: 400px;
    font-size: 15px;
    font-family: AndesMedium;
    /* These are technically the same, but use both */
    overflow-wrap: break-word;
    word-wrap: break-word;

    -ms-word-break: break-all;
    /* This is the dangerous one in WebKit, as it breaks things wherever */
    word-break: break-all;
    /* Instead use this non-standard one: */
    word-break: break-word;

    /* Adds a hyphen where the word breaks, if supported (No Blink) */
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
}
.referencesOverlay {
    //background: rgba(0, 0, 0, 0.5);
    background: @background;

    opacity: 0.5;
    -webkit-backdrop-filter: blur(10px);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
}
</style>
